module.exports = __webpack_public_path__ + "static/media/icon-docx.571bc66b.svg";